"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _config = require("./config");
var _common = require("../../../common");
var _amount = require("@/utils/amount");
var _api = require("../../../api");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import paginationEffect from '@/utils/paginationEffect';
var _default = exports.default = {
  name: 'EffectAnalysis',
  data: function data() {
    return {
      cards: _config.cards,
      commonData: _common.commonData,
      timeFormat: _common.timeFormat,
      // ...paginationEffect(this.handlerGetListData),
      tableData: {
        list: [],
        total: 0
      },
      loading: false,
      tableLoading: false,
      searchForm: {},
      info: {
        coupon: {}
      },
      isAdmin: false // 是否为管理员
    };
  },
  computed: {
    discountLines: function discountLines() {
      var coupon = this.info.coupon || {};
      var structured = this.buildStructuredDiscount(coupon);
      if (structured.length) {
        return structured;
      }
      if (coupon.couponDiscountInfo) {
        return coupon.couponDiscountInfo.split('\n').map(function (line) {
          return line && line.trim();
        }).filter(Boolean);
      }
      return [];
    }
  },
  created: function created() {
    // 判断用户是否为管理员（判断账号是否为admin）
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo') || '{}');
      this.isAdmin = JavaInfo.account === 'admin';
    } catch (error) {
      console.error('获取用户信息失败:', error);
      this.isAdmin = false;
    }
    var couponId = this.$route.path.split('/').pop();
    this.$set(this.searchForm, 'couponId', couponId);
    this.init();
    this.getDetail();
  },
  methods: {
    init: _common.init,
    tableCellStyle: function tableCellStyle(_ref) {
      var columnIndex = _ref.columnIndex;
      if (columnIndex === 0) {
        return {
          whiteSpace: 'normal',
          lineHeight: '22px'
        };
      }
      return {};
    },
    parseCouponDiscount: function parseCouponDiscount(raw) {
      if (!raw) return [];
      var parsed = raw;
      if (typeof raw === 'string') {
        try {
          parsed = JSON.parse(raw);
        } catch (error) {
          return [];
        }
      }
      return Array.isArray(parsed) ? parsed : [];
    },
    buildStructuredDiscount: function buildStructuredDiscount(coupon) {
      var _this = this;
      var list = this.parseCouponDiscount(coupon === null || coupon === void 0 ? void 0 : coupon.couponDiscount);
      if (!list.length) return [];
      return list.map(function (item) {
        if ((coupon === null || coupon === void 0 ? void 0 : coupon.couponType) === 2) {
          var unit = item.thresholdType === 2 ? '件' : '元';
          // 件的数量显示为整数，不保留小数
          var _threshold = item.thresholdType === 2 ? Math.floor(Number(item.threshold) || 0) : _this.formatAmountValue(item.threshold);
          return "\u6EE1".concat(_threshold).concat(unit, "\uFF0C\u6253").concat(_this.formatDiscountValue(item.discount), "\u6298");
        }
        var threshold = _this.formatAmountValue(item.threshold);
        return "\u6EE1".concat(threshold, "\u5143\uFF0C\u51CF").concat(_this.formatAmountValue(item.discount), "\u5143");
      });
    },
    formatAmountValue: function formatAmountValue(value) {
      if (value === null || value === undefined || value === '') return '0.00';
      var num = Number(value);
      var normalized = Number.isNaN(num) ? 0 : num;
      return (0, _amount.formatToYuan)(normalized, {
        showUnit: false,
        fractionDigits: 2
      });
    },
    formatDiscountValue: function formatDiscountValue(value) {
      if (value === null || value === undefined || value === '') return '0';
      var num = Number(value);
      if (Number.isNaN(num)) return value;
      var fixed = num.toFixed(2);
      return fixed.replace(/\.?0+$/, '');
    },
    formatCardValue: function formatCardValue(item, value) {
      if (item.isMark) {
        return this.formatYuan(value);
      }
      return this.formatNumber(value);
    },
    formatYuan: function formatYuan(value) {
      return (0, _amount.formatToYuan)(value, {
        fractionDigits: 2
      });
    },
    formatNumber: function formatNumber(value) {
      return (0, _amount.formatNumberWithComma)(value);
    },
    formatYuanColumn: function formatYuanColumn(row, column, cellValue) {
      return this.formatYuan(cellValue);
    },
    getDetail: function () {
      var _getDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _api.statisticsApi)(this.handleParams());
            case 2:
              res = _context.v;
              this.handleInfo(res);
              this.loading = false;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.loading = false;
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function getDetail() {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }(),
    handleInfo: function handleInfo(res) {
      this.info = res;
      this.tableData.list = res.couponStatisticsDetailVoList;
    },
    handleParams: function handleParams() {
      var params = _objectSpread({}, this.searchForm);
      if (params.time) {
        params.start = params.time[0];
        params.endT = params.time[1];
        delete params.time;
      }
      if (params.customerIds) {
        params.customerIds = params.customerIds.join(',');
      }
      return params;
    },
    // async search() {
    //   this.tableLoading = true;
    //   try {
    //     const res = await statisticsApi(this.searchForm);
    //     this.tableData = res
    //     this.tableLoading = false;
    //   } catch (error) {
    //     this.tableLoading = false;
    //   }
    // },
    customerFormatter: function customerFormatter(row) {
      var _row$customerResponse;
      return (_row$customerResponse = row.customerResponse) === null || _row$customerResponse === void 0 ? void 0 : _row$customerResponse.name;
    },
    // 获取第一个客户名称（如果distributionCustomersName是逗号分隔的多个客户名称）
    getFirstCustomerName: function getFirstCustomerName(customersName) {
      if (!customersName) return '';
      // 如果包含逗号，取第一个
      var names = customersName.split(',').map(function (name) {
        return name.trim();
      }).filter(function (name) {
        return name;
      });
      return names.length > 0 ? names[0] : customersName;
    }
  }
};